var render = function render(){var _vm=this,_c=_vm._self._c;return _c('circle',{attrs:{"cx":"50","cy":"50","fill":"none","stroke":"#07ce6f","stroke-width":"10","r":"35","stroke-dasharray":"164.93361431346415 56.97787143782138"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1s","values":"0 50 50;360 50 50","keyTimes":"0;1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }